import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

const SelectField = ({
  input,
  label,
  meta: { error, touched },
  children,
  defaultValue,
  disabled
}) => {
  return (
    <FormGroup>
      <Label>{label}</Label>
      <Input {...input} type="select" disabled={disabled}>
        {children}
      </Input>
      <div className="text-danger" style={{ marginBottom: '20px' }}>
        {touched && error}
      </div>
    </FormGroup>
  );
};

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/common/SelectField.js